const normalizeCopyText = (value?: string | null): string =>
  (value || "").replace(/\s+/g, " ").trim();

export const getRecommendationCopyHash = (
  copyParts: Array<string | null | undefined>
): string => {
  const normalizedCopy = copyParts.map(normalizeCopyText).join("|");

  if (!normalizedCopy) {
    return "0";
  }

  let hash = 2166136261;
  for (let i = 0; i < normalizedCopy.length; i += 1) {
    hash ^= normalizedCopy.charCodeAt(i);
    hash +=
      (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }

  return (hash >>> 0).toString(36);
};

export const getRecommendationDismissKey = (
  scope: string,
  recommendationKey: string
): string => `${scope}:${recommendationKey}`;
